<template>
    <div class="wrapper">
        <van-swipe :autoplay="3000" :indicator-color="$bus.red">
            <van-swipe-item 
            v-for="(image, index) in bannerlist"
            :key="index"
            >
            <van-image :src="image.img" width="6.94rem" height="2.52rem" radius="0.08rem" fit="cover"/>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
	import { Image, Swipe, SwipeItem } from 'vant';
	export default {
		components: {
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Image.name]: Image
		},
		data() {
			return {
				bannerdata:{},
				bannerlist:[{img:require('../assets/draft/banner.png')},{img:require('../assets/draft/banner1.png')}]
			}
		},
		created() {
			
		},
		methods: {
			// gourl(val){
			// 	console.log(val.split("=")[1])
			// 	if(val.split("=")[1]=="/pages/index/agentDevice/agentDeviceList?flag"){
			// 		this.$router.push({
			// 			path: '/assessList',
			// 			query: {
			// 				isvip: 1
			// 			}
			// 		});
			// 	}else{
			// 		window.location.href="http://www.tgj168.com/web/page/"+val.split("=")[1]+".html";
			// 	}
			// },
		}
	}
</script>
